import React, { useEffect, useRef, useState } from "react";

import img1 from "assets/invest/section-2-1.jpg";
import img1a from "assets/invest/section-2-1-a.jpg";
import img1b from "assets/invest/section-2-1-b.jpg";
import img1c from "assets/invest/section-2-1-c.jpg";
import { useAppContext } from "app/context/appContext";
const TargetVerticals = () => {
  const titleRef = useRef();
  const { windowWidth } = useAppContext();
  const [width, setWidth] = useState(windowWidth);

  useEffect(() => {
    setWidth(
      titleRef.current.offsetWidth +
        (windowWidth - titleRef.current.offsetWidth) / 2
    );
  }, [windowWidth]);
  return (
    <div className=" py-10 md:py-16 lg:py-24 flex flex-col gap-4 xl:gap-20 px-4 xl:px-8 max-w-[1400px] mx-auto">
      <div>
        <h1
          ref={titleRef}
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="500"
          className="text-neutral-1 w-fit mx-auto text-4xl md:text-6xl lg:text-7xl xl:text-7xl 3xl:text-[150px] text-center font-bold leading-tight px-4 mb-10 lg:mb-6">
          Target <span className="text-gr">Verticals</span>
        </h1>
      </div>
      <div className="flex flex-col-reverse items-center xl:items-start xl:flex-row justify-between gap-10 lg:gap-20 ">
        <div className="flex flex-col gap-6 lg:gap-12">
          <div
            className="flex flex-col gap-5"
            data-aos="fade-right"
            data-aos-duration="1500"
            data-aos-delay="1000">
            <span className="text-gr font-bold">PRIMARY:</span>
            <h1 className="font-bold text-2xl lg:text-5xl 3xl:text-6xl !leading-[1.2]">
              Esports, Marketing, Advertising Tech,{" "}
              <span className="whitespace-nowrap">E-Commerce</span>
            </h1>
            <p className="text-[#252525] font-medium text-sm lg:text-xl 3xl:text-2xl">
              Beladed allows users to participate in real-time livestream games
              and shows, making it a perfect fit for the esports and gaming
              industry. Beladed also leverages marketing tech, ad-tech, and
              e-commerce to offer a unique experience for users and advertisers
              through teams, tournaments and rewards.
            </p>
          </div>
          <div
            className="flex flex-col gap-5"
            data-aos="fade-right"
            data-aos-duration="1500"
            data-aos-delay="1500">
            <span className="text-gr font-bold">SECONDARY: </span>
            <h1 className="font-bold text-2xl lg:text-5xl 3xl:text-6xl !leading-[1.2]">
              Artificial Intelligence, CryptoCurrency,NFT, Augmented Reality,
              Virtual Reality
            </h1>
            <p className="text-[#252525] font-medium text-sm lg:text-xl 3xl:text-2xl">
              Beladed leverages AI for streamer and user benefits such as
              auto-generated text and images. Additionally, Beladed uses
              cryptocurrency and NFTs for in-platform transactions and engages
              with AR/VR to create dynamic experiences.
            </p>
          </div>
        </div>
        <div
          className="flex-shrink-0 grid grid-cols-3 grid-rows-[repeat(12, 1fr)] py-12 px-6 rounded-xl"
          style={{
            background:
              "linear-gradient(99.09deg, #6633cc2a 10.36%, #FF44B82a 98.61%)",
          }}>
          <div
            style={{ gridArea: " 1 / 1 / 7 / 3" }}
            data-aos="flip-right"
            data-aos-duration="1500"
            data-aos-delay="1000">
            <img src={img1a} alt="Target Verticals" className="rounded-lg" />
          </div>
          <div
            style={{ gridArea: " 4 / 2 / 10 / 4" }}
            data-aos="flip-left"
            data-aos-duration="1500"
            data-aos-delay="1500">
            <img src={img1b} alt="Target Verticals" className="rounded-lg" />
          </div>
          <div
            style={{ gridArea: "9 / 1 / 13 / 3" }}
            data-aos="flip-right"
            data-aos-duration="1500"
            data-aos-delay="2000">
            <img src={img1c} alt="Target Verticals" className="rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TargetVerticals;
